<i18n>
{
  "fr": {
    "ProductPageSlider": {
      "from": "À partir de",
      "unit": "unités !"
    }
  }
}
</i18n>

<template>
  <div v-if="isInit" class="product-page-slider">
    <div class="product-page-slider__unit-band">
      <span>
        {{ $t('ProductPageSlider.from') }} {{ unit }}
        {{ $t('ProductPageSlider.unit') }}
      </span>
    </div>
    <div class="product-page-slider__swiper">
      <Swiper
        class="swiper product-page-slider__swiper-container"
        :options="swiperOption"
      >
        <SwiperSlide v-for="(item, key) in items" :key="`image-product-${key}`">
          <img
            class="product-page-slider__image"
            :src="item"
            alt="image produit"
          />
        </SwiperSlide>
        <div
          slot="button-next"
          :class="`swiper-button-next swiper-button-next--${type}`"
        ></div>
        <div
          slot="button-prev"
          :class="`swiper-button-prev swiper-button-prev--${type}`"
        ></div>
      </Swiper>
    </div>
    <div class="product-page-slider__pagination">
      <div :class="`swiper-pagination swiper-pagination--${type}`"></div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

export default {
  name: 'ProductPageSlider',
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    items: { type: Array, default: () => [] },
    unit: { type: Number, default: 10 },
    type: { type: String, default: 'desktop' },
  },
  data() {
    return {
      isInit: false,
    };
  },
  computed: {
    swiperOption() {
      const productItems = this.items;
      return {
        observer: true,
        observeParents: true,
        keyboard: true,
        slidesPerView: 1,
        navigation: {
          nextEl: `.swiper-button-next--${this.type}`,
          prevEl: `.swiper-button-prev--${this.type}`,
        },
        pagination: {
          el: `.swiper-pagination--${this.type}`,
          clickable: true,
          bulletActiveClass: 'product-page-slider__thumbnail-container--active',
          progressbarOpposite: true,
          dynamicBullets: true,
          dynamicMainBullets: 3,
          renderBullet(index, className) {
            return `
              <span class="${className} product-page-slider__thumbnail-container">
                <img class="product-page-slider__thumbnail" src="${productItems[index]}" alt="" />
              </span>
            `;
          },
        },
      };
    },
  },
  created() {
    this.isInit = true;
  },
};
</script>

<style lang="scss">
@import '../../../../assets/sass/components/swiper';

.product-page-slider {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @include breakpoint($breakpoint-l) {
    justify-content: flex-start;
  }

  @include breakpoint($breakpoint-xxl) {
    flex-direction: row-reverse;
  }

  &__unit-band {
    position: absolute;
    font-size: 0.75em;
    font-style: italic;
    font-weight: lighter;
    right: -0.7em;
    top: 0.9em;
    padding: 0.375em 1em;
    color: $color-white;
    background-color: $color-red-punch;
    z-index: 5;

    @include breakpoint($breakpoint-l) {
      font-size: 1.25em;
    }
  }

  &__swiper {
    width: 100%;
    height: 14.75em;
    background: $color-white;
    overflow: hidden;

    @include breakpoint($breakpoint-xs) {
      height: 31.75em;
    }
  }

  &__swiper-container {
    height: 100%;
  }

  &__swiper-paginate-container {
    height: 100%;
  }

  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__pagination {
    width: 8.75em;

    @include breakpoint($breakpoint-xxl) {
      margin-right: 2.25em;
    }
  }

  &__thumbnail-container {
    margin: 0.3em;
    padding: 0.2em;
    display: none;
    transition: all ease-in-out 0.1s;
    cursor: pointer;

    > img {
      display: none;
    }

    &::before {
      content: '◦';
      font-size: 1.7em;
    }

    @include breakpoint($breakpoint-xxl) {
      width: 8.45em;
      height: 8.45em;
      margin: 0.55em;

      > img {
        display: block;
      }

      &::before {
        content: '';
        font-size: 1em;
      }
    }

    &--active {
      &::before {
        content: '•';
      }

      @include breakpoint($breakpoint-xxl) {
        border: 0.1em solid $color-red-punch;

        &::before {
          content: '';
        }
      }
    }

    &--active-main {
      display: block;
    }

    &--active-next,
    &--active-prev {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 2em;
      height: 2em;
      margin: 0;
      left: auto !important;
      background: none;
      font-size: 0.6em;

      > img {
        display: none;
      }

      &::after {
        display: none;
        @extend %icon;
        @extend %icon--arrow-right1;

        @include breakpoint($breakpoint-xxl) {
          display: block;
        }
      }

      @include breakpoint($breakpoint-xxl) {
        position: absolute;
        font-size: 1.4em;
      }
    }

    &--active-next {
      bottom: -1.5em;
      transform: rotate(90deg);

      &:hover {
        bottom: -1.6em;
      }
    }

    &--active-prev {
      top: -1.5em;
      transform: rotate(-90deg);

      &:hover {
        top: -1.6em;
      }
    }
  }

  &__thumbnail {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
